import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthRedirectGuard implements CanActivate {

  constructor(private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const currentUrl = state.url;  // obtengo la url de donde estoy
    const redirectUrl = this.getRedirectUrl();

    // una verificacion para evitar loops infinitos
    if (redirectUrl && currentUrl !== redirectUrl) {
      this.router.navigate([redirectUrl]);
      return false;  // regreso false para evaluar que no se active la ruta pues estoy donde mismo
    }

    return true;  // regreso true para evaluar que se active la ruta
  }

  private getRedirectUrl(): string | null {
    // para redireccionar dependiendo de la variable de ambiente
    switch (environment.Ambiente.toLowerCase()) {
      //ambientes trinitas
      case 'cdaTest'.toLowerCase():
        // localStorage.setItem('ambiente', 'cda');
        return '/logincda';
      default:
        return null;  // no redirigir a ningun lado y puedo entrar a todo
    }
  }
}